const formatAmount = (param?: string) => {
    if (param === null || param === undefined || param === "") {
      return "";
    }

    var param_splitted = param.split('.');
    var amount = param_splitted[0];
    var currency = amount.indexOf('$') >= 0;
    if (currency) {
      amount = amount.split('$')[1];
    }
    var decimals = param_splitted.length > 1 ? '.' + param_splitted[1] : '';
  
    var blocks = new Array<string>();
    for (var i = 1; i <= Math.floor(amount.length / 3) + 1; i++) {
      if ((amount.length - ((i - 1)) * 3) < 0) {
        blocks[i - 1] = amount.substring(0, ((amount.length - ((i - 1)) * 3) * -1))
      } else {
        blocks[i - 1] = amount.substring(amount.length - (i * 3), amount.length - ((i - 1) * 3))
      }
    }
  
    var reverse = blocks.reverse();
    var output = reverse.join(',');
  
    return (currency ? '$' : '') + (output.startsWith(',') ? output.substring(1, output.length) : output) + decimals;
}


const returnErrorFlag = (error: string) => {
  return error === '' ? false : true
}

const formatMoney = (amount: number): string =>  {
  return `$${amount.toLocaleString('en-US', { style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2 })}`;
}

export const utilities = {
    formatAmount,
    formatMoney,
    returnErrorFlag
}